(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const hero = document.querySelector('[data-stanlee-hero]');
  if (!hero) return;

  const media = hero.querySelector('[data-hero-parallax]');
  const spotlight = hero.querySelector('[data-hero-spotlight]');
  const content = hero.querySelector('[data-hero-content]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Background parallax + spotlight — reduced to a subtle 6px range (was 18px) */
  if (!reduceMotion) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;

      if (spotlight) {
        spotlight.style.setProperty('--x', (px * 100) + '%');
        spotlight.style.setProperty('--y', (py * 100) + '%');
      }
      if (media) {
        const moveX = (px - 0.5) * 6;
        const moveY = (py - 0.5) * 6;
        media.style.transform = `scale(1.06) translate(${moveX}px, ${moveY}px)`;
      }
    });
  }

  document.querySelectorAll('[data-smooth-scroll]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const targetSel = el.getAttribute('data-scroll-target') || el.getAttribute('href');
      const target = targetSel && document.querySelector(targetSel);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Magnetic buttons — barely-there movement (was up to 0.35, now a flat 0.06) */
  if (!reduceMotion) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.06}px, ${y * 0.06}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* Smooth fade + rise as the hero scrolls out of view, instead of an abrupt cutoff.
     Opacity eases from 1 -> 0.4 and the content lifts translateY(0 -> -60px)
     over the hero's own height. */
  if (!reduceMotion && content) {
    let ticking = false;

    const updateOnScroll = () => {
      const heroHeight = hero.offsetHeight || 1;
      const scrolled = Math.min(Math.max(window.scrollY, 0), heroHeight);
      const progress = scrolled / heroHeight;
      const opacity = Math.max(1 - progress * 0.6, 0.4);
      const translateY = progress * -60;
      content.style.opacity = opacity.toFixed(3);
      content.style.transform = `translateY(${translateY.toFixed(1)}px)`;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateOnScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stanlee-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /*
    PART 4/5 FIX: assets/stanlee-navigation.js (the single centralized
    controller for every category link on the site — mega menu, mobile
    accordion, and the Hero's Explore Products button) dispatches this
    event right before it scrolls the page and activates a tab. The
    header owns the mobile-menu/mega-menu DOM here, so it's the one
    that closes them — this keeps the closing logic in one place
    instead of duplicating it inside stanlee-navigation.js.
  */
  document.addEventListener('stanlee:close-menus', () => {
    closeMobile();
    document.querySelectorAll('.stanlee-nav__has-mega').forEach((item) => {
      item.classList.add('is-force-closed');
      window.setTimeout(() => item.classList.remove('is-force-closed'), 700);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stanlee-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const hero = document.querySelector('[data-stanlee-hero]');
  if (!hero) return;

  const media = hero.querySelector('[data-hero-parallax]');
  const spotlight = hero.querySelector('[data-hero-spotlight]');
  const content = hero.querySelector('[data-hero-content]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Background parallax + spotlight — reduced to a subtle 6px range (was 18px) */
  if (!reduceMotion) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;

      if (spotlight) {
        spotlight.style.setProperty('--x', (px * 100) + '%');
        spotlight.style.setProperty('--y', (py * 100) + '%');
      }
      if (media) {
        const moveX = (px - 0.5) * 6;
        const moveY = (py - 0.5) * 6;
        media.style.transform = `scale(1.06) translate(${moveX}px, ${moveY}px)`;
      }
    });
  }

  /* Generic smooth-scroll — only bound to elements WITHOUT data-category-link
     (e.g. the scroll-cue arrow), so the Explore Products button below is
     never handled by two listeners at once. */
  document.querySelectorAll('[data-smooth-scroll]:not([data-category-link])').forEach((el) => {
    el.addEventListener('click', (e) => {
      const targetSel = el.getAttribute('data-scroll-target') || el.getAttribute('href');
      const target = targetSel && document.querySelector(targetSel);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Magnetic buttons — barely-there movement (was up to 0.35, now a flat 0.06) */
  if (!reduceMotion) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.06}px, ${y * 0.06}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* Smooth fade + rise as the hero scrolls out of view, instead of an abrupt cutoff.
     Opacity eases from 1 -> 0.4 and the content lifts translateY(0 -> -60px)
     over the hero's own height. */
  if (!reduceMotion && content) {
    let ticking = false;

    const updateOnScroll = () => {
      const heroHeight = hero.offsetHeight || 1;
      const scrolled = Math.min(Math.max(window.scrollY, 0), heroHeight);
      const progress = scrolled / heroHeight;
      const opacity = Math.max(1 - progress * 0.6, 0.4);
      const translateY = progress * -60;
      content.style.opacity = opacity.toFixed(3);
      content.style.transform = `translateY(${translateY.toFixed(1)}px)`;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateOnScroll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
